import './CtaMagazine.scss'

import {ImageType, LinkType, WysiwygType} from '../../../types'
import React, {Fragment, useState} from 'react'

import {GiftSelections} from '../GiftSelections'
import {LinkEntryType} from '../../../campagne/types'
import {Picture} from '../../ui/Picture'
import {Theme} from '../../../views/Theme'
import {style} from '../../../util/style'
import {useHistory} from 'react-router'
import {useTranslation} from '../../../util/i18n'

const styles = style('ctamagazine', ['magazine'])

export type CtaMagazineType = {
	title: string
	title_overwrite?: string
	prices: Array<{
		price: number
		description?: WysiwygType
		information?: WysiwygType
	}>
	link?: LinkType
	magazine_image?: ImageType
	magazine_title?: string
	magazine_text?: WysiwygType
	magazine_link?: LinkType
	donation_link: LinkEntryType
}

type CtaMagazineMagazineType = {
	image?: ImageType
	title?: string
	text?: WysiwygType
	link?: LinkType
}

export const CtaMagazine: React.FC<CtaMagazineType & {container?: boolean}> = ({
	container,
	title,
	title_overwrite,
	prices,
	link,
	magazine_title,
	magazine_text,
	magazine_link,
	magazine_image,
	donation_link
}) => {
	const t = useTranslation().cta.magazine
	const history = useHistory()
	const ContainerTag = container ? Theme.Container : Fragment
	const [price, setPrice] = useState<number>(0)

	return (
		<div className={styles()}>
			<ContainerTag>
				{title && (
					<Theme.H3
						className={styles('title')}
						mod={['green', 'marked', 'slantleft']}
					>
						{title_overwrite || title}
					</Theme.H3>
				)}
				<div className={styles('row')}>
					<div className={styles('content')}>
						<GiftSelections
							className={styles('content-giftselections')}
							items={prices}
							showCustom={true}
							onChangeHandler={(newPrice: number) => setPrice(newPrice)}
						/>
						<div className={styles('content-button')}>
							<Theme.Button
								onClick={() => {
									if (donation_link)
										history.push(`${donation_link.url}?amt=${price}`)
								}}
								withIcon="arrow"
							>
								{t.btn_label}
							</Theme.Button>
						</div>
						{link?.url && (
							<div className={styles('content-link')}>
								<Theme.Link to={link.url}>
									{link.description || link.title}
								</Theme.Link>
							</div>
						)}
					</div>
					<CtaMagazineMagazine
						title={magazine_title}
						text={magazine_text}
						link={magazine_link}
						image={magazine_image}
					/>
				</div>
			</ContainerTag>
		</div>
	)
}

const CtaMagazineMagazine: React.FC<CtaMagazineMagazineType> = ({
	image,
	title,
	text,
	link
}) => {
	if (!title && !text) return null

	return (
		<div className={styles.magazine()}>
			{image && (
				<div className={styles.magazine('image')}>
					<Picture className={styles.magazine('image-img')} {...image} />
				</div>
			)}
			<div className={styles.magazine('content')}>
				{title && (
					<Theme.H3 className={styles.magazine('content-title')} mod="green">
						{title}
					</Theme.H3>
				)}
				{text && (
					<div className={styles.magazine('content-text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
			</div>
			{link?.url && (
				<Theme.Link to={link.url} className={styles.magazine('link')}>
					{link.description || link.title}
				</Theme.Link>
			)}
		</div>
	)
}
